import React from 'react';
import {
  bool,
  func,
  number,
  string,
} from 'prop-types';
import { IconContainer } from './image-icon.style';

/**
 * An icon component that takes an image src.
 * @param {object} params - Object containing props for this component
 * @param {string} src - Src of this icon's image file
 * @param {string} altString - The images specified alt string
 * @param {number} width - Width of the icon
 * @param {number} height - Height of the icon
 * @param {boolean} offcenter - If true, icon will not have vertical center styling
 */
const ImageIcon = ({
  src,
  width,
  height,
  altString,
  onClick,
  offCenter,
}) => (
  <IconContainer width={width} height={height} onClick={onClick} offCenter={offCenter}>
    <img
      src={src}
      alt={altString}
      width={`${width}px`}
      height={`${height}px`}
    />
  </IconContainer>
);

ImageIcon.propTypes = {
  src: string.isRequired,
  width: number.isRequired,
  height: number.isRequired,
  onClick: func,
  altString: string,
  offCenter: bool,
};

ImageIcon.defaultProps = {
  altString: 'alticon',
  onClick: null,
  offCenter: false,
};

export default ImageIcon;
